module.exports = "/assets/_next/static/images/logo-gold-600-7a7e89b6db1ffeaab025f2091d21b645.png";